import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { EdlEntriesFormBuilderService, EdlEntriesFormGroup, EdlEntry, User } from '@edl-development/edl-common';

@Injectable()
export class UserEntryFormBuilderService {

    constructor(
        private edlEntryFormBuilderService: EdlEntriesFormBuilderService,
    ) { }

    toSelectedEntries = (formGroup: EdlEntriesFormGroup<User>): User[] => {
        return this.edlEntryFormBuilderService
            .toSelectedEntries(formGroup)
            .map(this.entryToUser);
    }

    buildSelectedFormGroup = (users: User[], validators?: ValidatorFn[] | ValidatorFn | null): EdlEntriesFormGroup<User> => {
        const entries: EdlEntry<User>[] = users
            .map(user => this.userToEntry(user));

        return this.edlEntryFormBuilderService.buildSelectedFormGroup<User>(entries, validators);
    }

    updateSelectedFormGroup = (formGroup: EdlEntriesFormGroup<User>, users: User[]) => {
        const entries: EdlEntry<User>[] = users
            .map(user => this.userToEntry(user));

        return this.edlEntryFormBuilderService.updateSelectedFormGroup(formGroup, entries);
    }

    entryToUser = (entry: EdlEntry<User>): User => entry.details;

    userToEntry = (user: User): EdlEntry<User> => ({ 
        id: user.UserID, 
        name: `${user.FirstName} ${user.LastName}`, 
        details: user 
    });
}
